class QuickAddToCart extends window.BAO.CustomElement({
  SuperClass: HTMLButtonElement,
}) {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'click', this.onClickHandler)
  }

  async onClickHandler () {
    try {
      const variantId = this.dataset.variantId

      window.BAO.Cart.addItem({
        id: parseInt(variantId),
        quantity: 1,
      })
    } catch (error) {
      console.error('Error adding variant:', error)
    }
  }
}

customElements.define('quick-add-to-cart', QuickAddToCart, {
  extends: 'button',
})
